export default "__VITE_ASSET__d414f36f__"